import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        user_name: {
            user_name: null
        },
        user_edus: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        user_eduMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getUser_edusRequest({dispatch,commit, state}, payload) {
            // We check if app runs with backend mode

            if (payload){
                commit("SET_USERNAME", payload)
            }

            if (!config.isBackend) {
                dispatch("receiveUser_edus", null);
            } else {
                dispatch("receivingUser_edus"); // สถานะ กำลังบันทึก

                axios.get('/user_edus', { params: state.user_name }).then(res => {
                    dispatch("receiveUser_edus", res.data);
                })
                    .catch((e) => {
                        console.log(e);
                        dispatch("receiveUser_edus", null);
                    })
            }
        },
        loadUser_eduRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveUser_edu", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingUser_edu");
                axios.get('/user_edus/' + id).then(res => {
                    dispatch("receiveUser_edu", res.data);
                })
            }
        },
        updateUser_eduRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingUser_edu");
            axios.put('/user_edus/' + payload.edu_id, payload).then(res => {
                dispatch("updateUser_edu", res.data);
            })
        },
        createUser_eduRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingUser_edu");
            axios.post('/user_edus', payload).then(res => {
                dispatch("receiveUser_edu", res.data);
            })
        },
        deleteUser_eduRequest({dispatch}, payload) {

            dispatch("afterDeleteUser_edu", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingUser_edu", payload);

            axios.post('/delete_user_edus', payload).then(res => {
                dispatch("deleteUser_edu", {edu_id: payload.edu_id, res: res});
            })


        },
        receiveUser_edus({commit}, payload) {
            commit("RECEIVED_EDU_LEVELS", payload)
        },
        receivingUser_edus({commit}) {
            commit("RECEIVING_EDU_LEVELS") //call matutions --> state.isReceiving = true;
        },
        receiveUser_edu({commit}, payload) {
            commit("RECEIVED_EDU_LEVEL", payload)
        },
        receivingUser_edu({commit}) {
            commit("RECEIVING_EDU_LEVELS") //call matutions --> state.isReceiving = true;
        },
        updateUser_edu({commit}, payload) {
            commit("UPDATED_EDU_LEVEL", payload)
        },
        updatingUser_edu({commit}) {
            commit("UPDATING_EDU_LEVEL") //  call matutions --> state.isUpdating = true;
        },
        deleteUser_edu({commit}, payload) {
            commit("DELETED_EDU_LEVEL", payload)
        },
        deletingUser_edu({commit}, payload) {
            commit("DELETING_EDU_LEVEL", payload)
        },
        afterDeleteUser_edu({commit}, payload) {
            commit("AFFTER_DELETED_EDU_LEVEL", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_EDU_LEVELS(state, payload) {
            state.user_edus = payload;
            state.isReceiving = false;

        },
        RECEIVING_EDU_LEVELS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_EDU_LEVEL(state, payload) {


            if (payload.edu_id == undefined) {
                let error = !payload.e.errorInfo==true?payload.message:payload.e.errorInfo.toString()
                let user_eduMessage = 'พบข้อผิดพลาด :' + error
                state = Object.assign(state, {
                    isReceiving: false,
                    user_eduMessage: (state.user_eduMessage == user_eduMessage ? user_eduMessage + ' ' : user_eduMessage),

                });
            } else {
                let user_eduMessage = 'บันทึกสำเร็จ! รายการ ' + payload.edu_id + ' ถูกบันทึกแล้ว';

                state = Object.assign(state, {
                    user_edus: [...state.user_edus, payload],
                    isReceiving: false,
                    errorMessage: false,
                    user_eduMessage: (state.user_eduMessage == user_eduMessage ? user_eduMessage + ' ' : user_eduMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_EDU_LEVEL(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_EDU_LEVEL(state, payload) {


            let index = state.user_edus.findIndex(p => p.edu_id === payload.edu_id);
            let user_eduMessage = 'บันทึกสำเร็จ! รายการ ' + payload.edu_id + ' ถูกแก้ไขแล้ว';
            state = Object.assign(state, {
                user_edus: state.user_edus.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                user_eduMessage: (state.user_eduMessage == user_eduMessage ? user_eduMessage + ' ' : user_eduMessage),
            })
        },
        UPDATING_EDU_LEVEL(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_EDU_LEVEL(state, payload) {


            if (payload.edu_id == undefined || payload.res.data.message == 'Relation') {
                let user_eduMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.edu_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,

                    user_eduMessage: (state.user_eduMessage == user_eduMessage ? user_eduMessage + ' ' : user_eduMessage),

                });
            } else {
                let indexToDelete = state.user_edus.findIndex(p => p.edu_id === payload.edu_id);
                let user_edus = [...state.user_edus];
                user_edus.splice(indexToDelete, 1);
                let user_eduMessage = 'บันทึกสำเร็จ! รายการ ' + payload.edu_id + ' ถูกลบแล้ว';

                state = Object.assign(state, {
                    user_edus: [...user_edus],
                    isDeleting: false,
                    idToDelete: null,
                    user_eduMessage: (state.user_eduMessage == user_eduMessage ? user_eduMessage + ' ' : user_eduMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_EDU_LEVEL(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.edu_id;
        },
        AFFTER_DELETED_EDU_LEVEL(state) {
            state.errorMessage = false;

        },
        SET_USERNAME(state,payload) {
            state.user_name.user_name = payload.user_name;
            state.errorMessage=false;
            state.user_eduMessage='';

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
